// extracted by mini-css-extract-plugin
export default {"sales":"unsettledSales_sales__RKrIS","noresults":"unsettledSales_noresults__EJggM","message":"unsettledSales_message__JjMbQ","icon":"unsettledSales_icon__cHmiS"};